import { httpService } from '@/services/HttpService';

class ClientDataService {
  getClientData(workspaceId: any): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/billing`);
  }
  updateClientData(workspaceId: number, data: any): Promise<any> {
    return httpService.put(`workspaces/${workspaceId}/billing`, data);
  }
}

export const clientDataService = new ClientDataService();
